import { initVueApp } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/lib/utils/vue3compat/init_vue_app.js?vue3';
import SourceCodeDownloadDropdown from '/builds/gitlab/gitlab-ee/app/assets/javascripts/vue_shared/components/download_dropdown/download_dropdown.vue?vue3';

export default function initSourceCodeDropdowns() {
  const dropdowns = document.querySelectorAll('.js-source-code-dropdown');

  return dropdowns.forEach((el, index) => {
    const { downloadLinks, downloadArtifacts, cssClass } = el.dataset;

    return initVueApp({
      el,
      name: `SourceCodeDropdown${index + 1}`,
      provide: {
        downloadLinks,
        downloadArtifacts,
        cssClass,
      },
      component: SourceCodeDownloadDropdown,
      props: {
        downloadLinks: JSON.parse(downloadLinks) || [],
        downloadArtifacts: JSON.parse(downloadArtifacts) || [],
        cssClass,
      },
    });
  });
}
